import { getService } from 'react-in-angularjs';

export const closeNgModal = () => {
  const $mdDialog = getService('$mdDialog');
  $mdDialog.cancel();
};
